import {
  Directive,
  ElementRef,
  Input,
  Renderer2,
  ViewContainerRef
} from '@angular/core';
import { ErrorMessage } from '../../components/molecules/error-message/models/error-message.interfaces';
import { Shape } from '../../components/molecules/skeleton-loader/models/skeleton-loader.interface';
import { SkeletonMetaData } from './models/skeleton-loader.interface';
import { SkeletonLoaderService } from './services/skeleton-loader.service';

@Directive({
  selector: '[idpSkeletonLoader]'
})
export class SkeletonLoaderDirective {
  @Input() shape = {} as Shape;

  constructor(
    public element: ElementRef,
    public renderer: Renderer2,
    public viewContainerRef: ViewContainerRef,
    public skeletonLoaderService: SkeletonLoaderService
  ) {}

  @Input()
  set error(error: ErrorMessage | undefined) {
    if (error) {
      this.skeletonLoaderService.addError(
        error,
        this.element,
        this.viewContainerRef
      );
    }
  }

  @Input()
  set skeletonMetaData(skeletonMetaData: SkeletonMetaData) {
    if (
      this.skeletonLoaderService.checkForLoading(
        !skeletonMetaData.loaded,
        skeletonMetaData.disabled
      )
    ) {
      this.skeletonLoaderService.addLoader(
        this.element,
        this.renderer,
        this.viewContainerRef,
        this.shape
      );
    } else if (
      this.skeletonLoaderService.checkForLoading(
        skeletonMetaData.loaded,
        !skeletonMetaData.disabled
      )
    ) {
      this.skeletonLoaderService.removeLoader(this.element, this.renderer);
    } else if (
      this.skeletonLoaderService.checkForError(
        skeletonMetaData.loaded,
        skeletonMetaData.disabled,
        skeletonMetaData.error
      )
    ) {
      this.skeletonLoaderService.addError(
        skeletonMetaData.error as ErrorMessage,
        this.element,
        this.viewContainerRef
      );
    } else {
      this.skeletonLoaderService.removeLoader(
        this.element,
        this.renderer,
        true
      );
    }
  }
}
